export const Config = {
  ApiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  Token: process.env.REACT_APP_API_TOKEN,
}

if (!Config.ApiBaseUrl || !Config.Token) {
  throw new Error(
    "Missing URL or TOKEN. Copy .env.example to .env, fill in the values, and restart the dev server."
  )
}
